import Vue from 'vue';

export const permPlacementDetailsService = {
  async retrievePermPlacement(referenceNumber) {
    return Vue.axios.get(`/perm-placements/${referenceNumber}`).then(response => response.data);
  },
  async retrievePermPlacementAttachments(referenceNumber, sortOrder) {
    return Vue.axios
      .get(`/perm-placements/${referenceNumber}/attachments`, {
        params: {
          ...sortOrder
        }
      })
      .then(response => response.data);
  },
  async retrievePermPlacementHistories(referenceNumber, sortOrder) {
    return Vue.axios
      .get(`/perm-placements/${referenceNumber}/history`, {
        params: {
          ...sortOrder
        }
      })
      .then(response => response.data);
  },
  async doPermPlacementAction(perm, action) {
    let actionUrl = perm.reference_number
      ? `/perm-placements/${perm.reference_number}?action=${action}`
      : `/perm-placements/create?action=${action}`;

    return Vue.axios
      .post(actionUrl, {
        ...perm
      })
      .then(response => response.data);
  }
};
